export default "__VITE_ASSET__CUoYs3Fw__"